<template>
  <v-sheet rounded="lg">
    <v-container id="EventAdder">
      <h1>{{ header | textPreview(20) }}</h1>
      <v-row justify="center" v-if="template">
        <v-col>
          <v-date-picker
            v-model="picker"
            :events="templateEvents"
            locale="de-DE"
            first-day-of-week="1"
            show-adjacent-months
          ></v-date-picker>
          <v-btn block color="warning" @click="addEvent" :disabled="loading || undefined === picker" :loading="loading">
            im Kalender eintragen
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "EventAdder",
  props: { template: Object, events: Array },
  data: function () {
    return {
      picker: undefined,
      loading: false,
    };
  },
  mounted() {
    const eventAdder = document.querySelector("#EventAdder");
    this.$vuetify.goTo(eventAdder);
  },
  watch: {
    template: function () {
      const eventAdder = document.querySelector("#EventAdder");
      this.$vuetify.goTo(eventAdder);
    },
  },
  computed: {
    header: function () {
      return this.template ? this.template.summary : "Zeitvorlage auswählen";
    },
    templateEvents: function () {
      return this.events.filter((val) => val.summary === this.template.summary).map((val) => val.start.dateTime.substr(0, 10));
    },
  },
  methods: {
    addEvent() {
      this.loading = true;
      const event = {
        summary: this.template.summary,
        location: this.template.location,
        description: this.template.description,
        start: {
          dateTime: this.picker + "T" + this.template.start + ":00",
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        end: {
          dateTime: this.picker + "T" + this.template.end + ":00",
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        attendees: this.template.attendees,
        reminders: this.template.reminders,
      };
      console.debug(event);
      this.$gapi.getGapiClient().then((gapi) => {
        gapi.client.calendar.events
          .insert({
            calendarId: "primary",
            sendUpdates: "all",
            resource: event,
          })
          .then((response) => {
            this.$emit("show-snack-bar", "Der Termin wurde erfolgreich im Kalender eingetragen.", "success");
            this.$emit("add-event", response.result);
            this.loading = false;
          })
          .catch((error) => {
            this.$emit("show-snack-bar", "Eintragen des Termins im Kalender fehlgeschlagen.", "error");
            console.error(error);
            this.loading = false;
          });
      });
    },
  },
  filters: {
    textPreview: function (text, max) {
      if ("string" !== typeof text) return "n/s";
      if (max <= 3) return "...";
      if (max < text.length) return text.slice(0, max - 3) + "...";
      return text;
    },
  },
};
</script>

<style></style>
